export default __webpack_public_path__ + "static/media/betonred.b2d7dc5d.svg";